import styled from '../../../../../styles/styledComponents/themeComponents';

interface TabsStyleProps {
  tabColorSet: {
    background?: string;
    active?: string;
    inactive?: string;
  };
  tabLength: number;
}
export const TabsStyle = styled.div<TabsStyleProps>`
  position: sticky;
  top: 0;
  display: flex;
  height: 60px;
  line-height: 60px;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: ${(props) => props.tabColorSet.background};
  border-bottom: 1px solid rgb(229, 229, 229);
  z-index: ${(props) => props.theme.zIndex.default};

  .tab-title {
    position: relative;
    text-align: center;
    padding: 0;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: -0.2px;
    cursor: pointer;

    &.active {
      color: ${(props) => props.tabColorSet.active};

      &:after {
        position: absolute;
        display: block;
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
        background-color: black;
        background-color: ${(props) => props.tabColorSet.active};
      }
    }
    &.inactive {
      color: ${(props) => props.tabColorSet.inactive};

      &:after {
        background-color: ${(props) => props.tabColorSet.inactive};
      }
    }
  }

  &.full {
    .tab-title {
      width: ${(props) => 100 / props.tabLength}%;
      ${(props) => props.theme.ellipsis}
    }
  }

  &.variable {
    .tab-title {
      flex-grow: 1;
      flex-shrink: 0;
      padding: 0 16px;

      &:after {
        left: 11px;
        right: 11px;
      }
    }
  }
`;
